import React, { useEffect } from 'react';
import { ReactComponent as CircleCheck } from '../../assets/CircleCheck.svg';
import { useAnalytics } from '../../utils/useAnalytics';

import styles from './styles.module.scss';

type ConfirmationProps = {
  title: string;
  children?: React.ReactElement;
  hideIcon?: boolean;
  cta?: 'deepLink' | 'contactSupport';
  parentPage?: string;
};

export const Confirmation = ({ title, children, hideIcon, cta, parentPage }: ConfirmationProps) => {
  const {
    trackRegisterSuccessfulPageOpenTempoAppTapped,
    trackExistingSubscriptionPageContactSupportTapped,
    trackSubscriptionInvitationConfirmationPageOpenTempoAppTapped,
    trackExistingSubscriptionPageViewed,
    getFormData,
  } = useAnalytics();

  useEffect(() => {
    if (parentPage === 'register' && cta === 'contactSupport') {
      const registerFormSavedData = getFormData('register_form');
      trackExistingSubscriptionPageViewed(registerFormSavedData);
    }
  }, [parentPage, cta]);

  const handleCtaClicked = () => {
    if (parentPage == 'register') {
      const registerFormSavedData = getFormData('register_form');
      if (cta === 'deepLink' && registerFormSavedData) {
        trackRegisterSuccessfulPageOpenTempoAppTapped(registerFormSavedData);
      }
      if (cta === 'contactSupport' && registerFormSavedData) {
        trackExistingSubscriptionPageContactSupportTapped(registerFormSavedData);
      }
    }
    if (parentPage == 'invite') {
      const inviteFormSavedData = getFormData('invite_form');
      if (cta === 'deepLink' && inviteFormSavedData) {
        trackSubscriptionInvitationConfirmationPageOpenTempoAppTapped(
          inviteFormSavedData.email,
          inviteFormSavedData.invite_code
        );
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {!hideIcon && <CircleCheck />}

        <h1 className={styles.header}>{title}</h1>
        <div className={styles.text}>{children}</div>
        {cta === 'deepLink' && (
          <a href="https://links.tempo.fit/" className={styles.ctaButton} onClick={handleCtaClicked}>
            Open Tempo App
          </a>
        )}
        {cta === 'contactSupport' && (
          <a
            href="https://support.tempo.fit/contact/contact-us-ByRoFp10w"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.ctaButton}
            onClick={handleCtaClicked}
          >
            Contact Support
          </a>
        )}
      </div>
    </div>
  );
};
